import styled from 'styled-components';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

export const InstitutionItemStyle = styled.div`
  &.selected {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .institution-list-item {
    align-items: center;
    background-color: ${colors.mostlyWhite};
    border-radius: 19px;
    display: flex;
    flex-direction: row;
    height: 110px;
    margin-bottom: 8px;
    padding-left: 5%;
    padding-right: 5%;
    position: relative;
    width: 100%;

    &.selected {
      display: flex;
      flex-direction: column;
      height: 239px;
      justify-content: flex-start;
      margin-bottom: 10px;
      min-width: 230px;
      padding-top: 17px;
      position: relative;
      width: 100%;
    }

    .options-gallery {
      ${zIndex.hills};
      background-color: ${colors.veryPaleBlue};
      border-radius: 19px;
      height: 130px;
      position: absolute;
      right: 5px;
      top: 55px;
      width: 300px;

      .option {
        ${fontFamily.sourceSansPro.bold};
        align-items: center;
        color: ${colors.veryDarkGrayishBlue};
        display: flex;
        flex-direction: row;
        font-size: 14px;
        height: 50%;
        justify-content: flex-start;
        padding-left: 30px;
        width: 100%;

        .icon-container {
          height: 20px;
          margin-right: 16px;
          width: 20px;

          svg {
            fill: ${colors.veryDarkGrayishBlue};
            height: 20px;
            width: 20px;
          }
        }
      }
    }

    @media (min-width: ${breakpoints.wxgaPlus.width}px) {
      align-items: center;
      display: flex;
      flex-direction: row;
      height: 81px;
      justify-content: flex-start;
      padding-left: 22px;
      padding-right: 31px;

      &.selected {
        height: 239px;
        width: 100%;
      }
    }

    .options-icon {
      align-items: center;
      background-color: transparent;
      border-radius: 50%;
      display: flex;
      flex-direction: row;
      height: 25px;
      justify-content: center;
      position: absolute;
      right: 25px;
      top: 17px;
      transition: background-color 500ms;
      width: 25px;

      svg {
        fill: ${colors.grayishBlue};
        height: 4px;
        width: 18px;
      }
    }

    .options-icon:hover {
      background-color: ${colors.lightGrayishBlue};
    }

    .logo-container {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;

      &.selected {
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 17px;
        width: 100%;
      }

      .institution-photo {
        align-items: center;
        border-radius: 50%;
        display: block;
        display: flex;
        height: 60px;
        justify-content: center;
        margin-right: 20px;
        overflow: hidden;
        width: 60px;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          margin-right: 43px;
        }

        img {
          display: block;
          min-height: 100%;
          width: 100%;

          &.selected {
            align-items: center;
            display: flex;
            flex-direction: row;
            height: 81px;
            justify-content: center;
            margin-right: 12px;
            max-width: 81px;
            min-width: 81px;
            padding: 0;
            width: 81px;
          }
        }
      }
      .logo-placeholder {
        background-color: ${colors.lightGrayishBlue};
        border-radius: 50%;
        margin-right: 20px;
        max-width: 60px;
        min-width: 60px;
        padding: 16px 0;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          margin-right: 43px;
        }

        &.selected {
          align-items: center;
          display: flex;
          flex-direction: row;
          height: 81px;
          justify-content: center;
          margin-right: 12px;
          max-width: 81px;
          min-width: 81px;
          padding: 0;
          width: 81px;
        }

        .logo-placeholder-content {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.veryPaleBlue};
          display: block;
          font-size: 24px;
          line-height: 28px;
          text-align: center;

          &.selected {
            font-size: 32px;
            line-height: 33px;
          }
        }
      }
    }

    .institution-information {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      max-height: 60px;
      min-height: 60px;
      position: relative;
      width: 100%;

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
      }

      &.selected {
        justify-content: space-between;
      }

      .institution-name-item {
        min-width: 130px;
        width: 26%;
        word-break: keep-all;

        &.selected {
          display: none;
          padding-left: 30%;
        }
      }

      .registration-item {
        display: none;
        width: 22%;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          display: block;
        }

        span {
          margin-left: 5px;
        }

        &.selected {
          align-items: center;
          display: flex;
          margin-bottom: 15px;
          width: 100%;

          .icon-container {
            align-items: center;
            display: flex;
            width: 23px;

            svg {
              height: 20px;
              width: 20px;
            }
          }
        }
      }

      .exams-item {
        display: none;
        width: 21%;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          display: flex;
        }

        span {
          margin-left: 5px;
          width: 100%;
        }

        &.selected {
          align-items: center;
          display: flex;
          margin-bottom: 15px;
          margin-top: 5px;
          width: 100%;

          .icon-container {
            align-items: center;
            display: flex;
            width: 23px;

            svg {
              height: 20px;
              width: 15px;
            }
          }
        }
      }

      .administrator-list-item {
        width: 100%;
        word-break: keep-all;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          width: 20%;
        }

        &.selected {
          align-items: center;
          display: flex;
          width: 100%;

          .icon-container {
            align-items: center;
            display: flex;
            width: 23px;

            svg {
              height: 20px;
              width: 16px;
            }
          }
        }

        span {
          margin-left: 5px;
        }
      }

      .actions-list-item {
        bottom: 0;
        position: absolute;
        right: 0;
        width: 60px;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          align-items: center;
          display: flex;
          flex-direction: row;
          height: 100%;
          justify-content: center;
          position: relative;
          width: 20%;
        }

        &.selected {
          display: none;
        }

        .actions-item {
          display: flex;
          flex-direction: row;
          justify-content: center;
          width: 100%;

          .edit-button {
            margin-right: 15px;
          }

          svg {
            fill: ${colors.grayishBlue};
            height: 20px;
            width: 20px;
          }
        }
      }

      .go-to-user-text {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.softBlue};
        font-size: 11px;
        position: absolute;
        right: 0;
        top: 0;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          display: none;
        }
      }
    }
  }
`;
